import PwaInstallInstruction from './PwaInstallInstruction';

export default PwaInstallInstruction;
